/**
 * Number and time wording for the profile window. Plain spaces between the
 * digit groups: the generated font has no narrow no-break space, which
 * `toLocaleString('fr-FR')` would put there.
 */

import { uiFormat, uiText } from './text.js';

export function formatCount(value: number): string {
  return String(Math.floor(value)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

export function formatDuration(seconds: number): string {
  const minutes = Math.floor(seconds / 60);
  if (minutes < 1) return uiFormat('moins d’une minute', {});
  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;
  if (hours === 0) return uiFormat('{minutes} min', { minutes });
  return rest === 0
    ? uiFormat('{hours} h', { hours: formatCount(hours) })
    : uiFormat('{hours} h {minutes} min', { hours: formatCount(hours), minutes: rest });
}

const MONTHS = [
  'janvier',
  'février',
  'mars',
  'avril',
  'mai',
  'juin',
  'juillet',
  'août',
  'septembre',
  'octobre',
  'novembre',
  'décembre',
] as const;

/** « 14 septembre 2026 », or nothing for a date the server sent garbled. */
export function formatDate(iso: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '';
  const month = MONTHS[date.getMonth()] ?? '';
  return uiFormat('{day} {month} {year}', {
    day: date.getDate(),
    month: uiText(month),
    year: date.getFullYear(),
  });
}
